export default class Poller {
  constructor() {
    this.pollerInstance = null;
  }

  refresh(callBack, interval) {
    // Make initial request
    callBack();
    // set poller
    this.pollerInstance = setInterval(callBack, interval);
  }

  stop() {
    if (this.pollerInstance) {
      clearInterval(this.pollerInstance);
      this.pollerInstance = null;
    }
  }

  start(callBack, interval) {
    if (this.pollerInstance) {
      clearInterval(this.pollerInstance);
    }
    this.refresh(callBack, interval);
  }

  alive() {
    return !!this.pollerInstance;
  }
}
